import React, { memo, useMemo } from 'react';
import EmbeddedReportViewer from '../../../../custom-components/embedded-reports/EmbeddedReportViewer';
import { useFormContext } from 'react-hook-form';
import { get } from 'lodash-es';

const MemoizedEmbeddedReportViewer = memo(EmbeddedReportViewer);

const EmbeddedFormReportViewer = ({ props: { reportIdentifier, queryParams, hideBreadcrumbs } }) => {
    const { selectedValues } = useFormContext();
    const selectValues = useMemo(
        () =>
            queryParams?.reduce((acc, value) => {
                const propertyValue = value.property != null ? get(selectedValues[value.field], value.property) : selectedValues[value.field];
                if (propertyValue != null) {
                    return { ...acc, [value.rename ?? value.property ?? value.field]: propertyValue };
                }
                return acc;
            }, {}),
        [selectedValues]
    );

    return <MemoizedEmbeddedReportViewer reportIdentifier={reportIdentifier} queryParams={selectValues} hideBreadcrumbs={hideBreadcrumbs} />;
};

export default EmbeddedFormReportViewer;
